import { render } from "./Company.vue?vue&type=template&id=0684d1be&scoped=true&ts=true"
import script from "./Company.vue?vue&type=script&lang=ts"
export * from "./Company.vue?vue&type=script&lang=ts"

import "./Company.vue?vue&type=style&index=0&id=0684d1be&scoped=true&lang=css"

import exportComponent from "/Users/rickvanwell/Work/Signals/webui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0684d1be"]])

export default __exports__